import { createDateFromString } from '../../helpers/DateFormatUtil';

// sort the articles by date
const sortArticlesByDate = (articles) => {
  articles.sort((a, b) => createDateFromString(b.date) - createDateFromString(a.date));
  return articles;
};

// picks articles based on year for the current and previous year
const filterArticlesByYear = (content, pickedYear) => {
  const currYear = new Date().getFullYear();
  const diffYear = currYear - parseInt(pickedYear, 10);

  const filteredContent = content.filter(val => (diffYear > 1
    ? val.year <= pickedYear : val.year === pickedYear));

  return filteredContent;
};

export { sortArticlesByDate, filterArticlesByYear };
